(function(){
  if(!document.querySelector('.fo2-wrap')) return;
  var old = document.querySelector('.fo2-hero-carousel') || document.querySelector('.fo2-hero-visual') || document.getElementById('fo2HeroCarousel');
  if(!old) return;
  if(document.getElementById('fo2Gallery')) return; // already injected
  
  var urls = [
    'https://cdn.shopify.com/s/files/1/0549/4430/1193/files/01-product-hero.png?v=1779720035',
    'https://cdn.shopify.com/s/files/1/0549/4430/1193/files/02-bundle-offer.png?v=1779720035',
    'https://cdn.shopify.com/s/files/1/0549/4430/1193/files/03-social-proof.png?v=1779720036',
    'https://cdn.shopify.com/s/files/1/0549/4430/1193/files/04-what-to-expect.png?v=1779720037',
    'https://cdn.shopify.com/s/files/1/0549/4430/1193/files/05-stats-evidence.png?v=1779720037',
    'https://cdn.shopify.com/s/files/1/0549/4430/1193/files/06-ingredients.png?v=1779720038'
  ];
  var alts = ['Pure Greens produkt','Tilbud','Trustpilot','Hvad kan du forvente','Produktet i tal','Ingredienser'];
  
  var gal = document.createElement('div');
  gal.id = 'fo2Gallery';
  
  var main = document.createElement('div');
  main.style.cssText = 'border-radius:20px;overflow:hidden;aspect-ratio:1/1;background:#fff;box-shadow:0 24px 48px -24px rgba(1,72,62,0.25);position:relative;';
  
  urls.forEach(function(u, i) {
    var img = document.createElement('img');
    img.src = u; img.alt = alts[i];
    img.style.cssText = 'width:100%;height:100%;object-fit:contain;display:' + (i===0?'block':'none') + ';position:' + (i===0?'relative':'absolute') + ';top:0;left:0;';
    if(i===0) img.classList.add('active');
    main.appendChild(img);
  });
  
  function mkA(sym, pos) {
    var b = document.createElement('button');
    b.innerHTML = sym;
    b.style.cssText = 'position:absolute;top:50%;transform:translateY(-50%);' + pos + ':12px;width:44px;height:44px;border-radius:50%;background:rgba(255,255,255,0.92);border:1px solid rgba(0,0,0,0.06);box-shadow:0 2px 12px rgba(0,0,0,0.1);display:flex;align-items:center;justify-content:center;cursor:pointer;z-index:2;font-size:22px;color:#01483E;line-height:1;';
    return b;
  }
  var pB = mkA('\u2039', 'left');
  var nB = mkA('\u203A', 'right');
  main.appendChild(pB);
  main.appendChild(nB);
  gal.appendChild(main);
  
  var tR = document.createElement('div');
  tR.style.cssText = 'display:flex;gap:8px;margin-top:12px;justify-content:center;';
  urls.forEach(function(u, i) {
    var th = document.createElement('div');
    th.className = 'gth';
    th.style.cssText = 'width:80px;height:80px;border-radius:12px;overflow:hidden;border:2.5px solid ' + (i===0?'#01483E':'transparent') + ';cursor:pointer;transition:border-color 0.2s;background:#fff;flex-shrink:0;';
    var ti = document.createElement('img');
    ti.src = u; ti.style.cssText = 'width:100%;height:100%;object-fit:cover;display:block;';
    th.appendChild(ti);
    tR.appendChild(th);
  });
  gal.appendChild(tR);
  
  old.parentNode.replaceChild(gal, old);
  
  var imgs = main.querySelectorAll('img');
  var ths = tR.querySelectorAll('.gth');
  var c = 0;
  function sh(i) {
    imgs[c].style.display = 'none';
    imgs[c].style.position = 'absolute';
    imgs[c].classList.remove('active');
    ths[c].style.borderColor = 'transparent';
    c = (i + imgs.length) % imgs.length;
    imgs[c].style.display = 'block';
    imgs[c].style.position = 'relative';
    imgs[c].classList.add('active');
    ths[c].style.borderColor = '#01483E';
  }
  pB.onclick = function() { sh(c-1); };
  nB.onclick = function() { sh(c+1); };
  ths.forEach(function(t, i) { t.onclick = function() { sh(i); }; });
  
  var sx = 0;
  main.addEventListener('touchstart', function(e) { sx = e.touches[0].clientX; }, {passive:true});
  main.addEventListener('touchend', function(e) {
    var dx = e.changedTouches[0].clientX - sx;
    if(Math.abs(dx) > 40) { dx < 0 ? sh(c+1) : sh(c-1); }
  }, {passive:true});
})();
